// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"ab628ea2","223":"58023d26","593":"4cd94bd0","599":"59bbcf75","858":"06532323","877":"6b4bd376"}[chunkId] + ".chunk.js";
};